module.exports = __webpack_public_path__ + "img/discount-large.cdf8ca31.svg";